import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import type { DomainOverviewTechnology } from './split-view.interface'

export interface DomainOverviewTechnologiesProps {
  technologyList: DomainOverviewTechnology[]
}

export const DomainOverviewTechnologies: React.FC<DomainOverviewTechnologiesProps> = ({
  technologyList,
}): ReactNode => (
  <div className="domain-technologies">
    <h3 className="mb-3 text-sm font-semibold">Detected Technologies</h3>
    <div className="flex flex-wrap gap-2">
      {technologyList.map((tech) => (
        <Badge
          key={tech.name}
          variant="outline"
          className="domain-technology flex items-center gap-1.5"
        >
          <span>{tech.name}</span>
          <span className="text-muted-foreground">({tech.category})</span>
        </Badge>
      ))}
    </div>
  </div>
)
